import { useLocStrings } from '@office-start/loc-service';
import { useConstructCdnUrl } from '@office-start/url-parser-utility';
import React, { useMemo } from 'react';
import { useM365LogoStyles } from './M365Logo.styles';
export var M365Logo = function () {
    var _a;
    var styles = useM365LogoStyles();
    var localizedStrings = useLocStrings().data;
    return (React.createElement("span", { className: styles.container },
        React.createElement("img", { className: styles.content, id: "M365Logo", alt: (_a = localizedStrings === null || localizedStrings === void 0 ? void 0 : localizedStrings.announcementBannerResources) === null || _a === void 0 ? void 0 : _a.m365LogoAltText, src: useMicrosoftLogoSvgCdnUrl() })));
};
var useMicrosoftLogoSvgCdnUrl = function () {
    var constructCdnUrl = useConstructCdnUrl();
    return useMemo(function () {
        return constructCdnUrl({
            fileName: 'm365-logo_light_and_dark',
            fileExtension: 'svg',
        });
    }, [constructCdnUrl]);
};
//# sourceMappingURL=M365Logo.js.map